import { useLocation } from 'react-router-dom'
import PropTypes from 'prop-types'
import {
  ROUTE_ACCOUNT_MANAGE_CARD,
  ROUTE_ACCOUNT_INFO_AND_SECURITY,
  ROUTE_ACCOUNT_MORE,
  ROUTE_HOME,
  ROUTE_TRANSACTIONS_ALL_TRANSACTIONS,
  ROUTE_TRANSACTIONS_STATEMENTS,
  ROUTE_PAYMENTS_AUTO_PAY,
  ROUTE_PAYMENTS_MAKE_PAYMENT,
  ROUTE_PAYMENTS_PAYMENT_HISTORY,
  ROUTE_PAYMENTS_PAYMENT_METHODS,
  ROUTE_PAYMENT_PAY_BY_CHECK,
  ROUTE_REWARDS_BENEFITS,
  ROUTE_REWARDS_MY_REWARDS,
  ROUTE_REWARDS_TRAVEL,
  ROUTE_VEHICLES_MANAGE_VEHICLES,
  ROUTE_VEHICLES_EARNINGS,
} from '@/routes/paths'
import { PlaidCannotMonitorHeaderBanner } from './plaid-cannot-monitor-banner'
import PlaidNoLinkBanner from './plaid-no-link-banner'

const BannerType = {
  PLAID_NO_LINKED_BANK_ACCOUNT: 'PLAID_NO_LINKED_BANK_ACCOUNT',
  PLAID_NO_MONITORABLE_BANK_ACCOUNT: 'PLAID_NO_MONITORABLE_BANK_ACCOUNT',
  NONE: 'NONE',
}

const PersistentHeaderBanner = ({ setIsLoading, bannerType = BannerType.NONE }) => {
  const pathname = useLocation().pathname.split('/').at(-1)
  const showBanner = showBannerByPath(pathname, bannerType)
  const bannerClass = getBannerClass(pathname)

  if (bannerType === BannerType.NONE || !showBanner) {
    return null
  }

  return (
    <div className={bannerClass}>
      <div className="flex flex-col md:gap-8 gap-5">
        {bannerType === BannerType.PLAID_NO_MONITORABLE_BANK_ACCOUNT && <PlaidCannotMonitorHeaderBanner />}
        {bannerType === BannerType.PLAID_NO_LINKED_BANK_ACCOUNT && <PlaidNoLinkBanner setIsLoading={setIsLoading} />}
      </div>
    </div>
  )
}

function showBannerByPath(pathname, bannerType) {
  const standardRoutes = [
    ROUTE_HOME,
    ROUTE_ACCOUNT_MANAGE_CARD,
    ROUTE_ACCOUNT_INFO_AND_SECURITY,
    ROUTE_ACCOUNT_MORE,
    ROUTE_TRANSACTIONS_ALL_TRANSACTIONS,
    ROUTE_TRANSACTIONS_STATEMENTS,
    ROUTE_REWARDS_BENEFITS,
    ROUTE_REWARDS_MY_REWARDS,
    ROUTE_REWARDS_TRAVEL,
    ROUTE_VEHICLES_MANAGE_VEHICLES,
    ROUTE_VEHICLES_EARNINGS,
  ]
  const paymentRoutes = [
    ROUTE_PAYMENTS_AUTO_PAY,
    ROUTE_PAYMENTS_MAKE_PAYMENT,
    ROUTE_PAYMENTS_PAYMENT_HISTORY,
    ROUTE_PAYMENTS_PAYMENT_METHODS,
    ROUTE_PAYMENT_PAY_BY_CHECK,
  ]

  const showOnStandard = standardRoutes.includes(pathname)
  const showOnPayment = paymentRoutes.includes(pathname) && bannerType !== BannerType.PLAID_NO_MONITORABLE_BANK_ACCOUNT

  return showOnStandard || showOnPayment
}

function getBannerClass(pathname) {
  return [ROUTE_HOME, ROUTE_TRANSACTIONS_ALL_TRANSACTIONS, ROUTE_TRANSACTIONS_STATEMENTS].includes(pathname)
    ? 'md:px-[10%] md:mt-[2%] bg-bgGray md:m-0 mx-0 my-6'
    : 'md:px-[10%] md:mt-[2%] bg-bgGray md:m-0 mx-6 mt-6'
}

PersistentHeaderBanner.propTypes = {
  setIsLoading: PropTypes.func,
  bannerType: PropTypes.oneOf(Object.values(BannerType)),
}

export { BannerType }
export default PersistentHeaderBanner
